var tag = document.createElement('script'), 
firstScriptTag = document.getElementsByTagName('script')[0], 
player = new Array(), 
theID, 
checkCurrentTime,
vimeo_player = {},
$ = jQuery;

//Just a little hack to stop related videos from showing when the video has finished
function whilePlayBack(event){
    var $duration = event.target.getDuration(); $duration -= 1;checkCurrentTime = setTimeout(function(){
    if(event.target.getCurrentTime() >= $duration){event.target.stopVideo();}whilePlayBack(event);},100);
}

function onPlayerStateChange(event){
    var theID = $('#'+event.target.h.id);

    if(event.data == 1){
        whilePlayBack(event);
        if( theID.closest('.news-grid-item').length == 1 ){
            theID.parent().prev('.content').fadeOut();
        }
        
    } else {
        clearTimeout(checkCurrentTime);
        if( theID.closest('.news-grid-item').length == 1 ){
            theID.parent().prev('.content').fadeIn();
        }
    }
}

//Add Youtube and Vimeo API
$(document).ready(function(){
    tag.src = "https://www.youtube.com/iframe_api";
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
});


$(document).ready(function(){
$('.vimeo').each(function(){
    var theId = $(this).attr('id');
    var iframe = document.getElementById(theId);
    vimeo_player[theId] = $f(iframe);
});
});

function onYouTubeIframeAPIReady() {
    $('.youtube_video_container').each(function(){
        var ytid = $(this).attr('data-ytid'),
        theID = $(this).attr('id'),
        ytcontrols = typeof $(this).attr('data-controls') != 'data-controls="1"' ? $(this).attr('data-controls')  : 0;
        muted = typeof $(this).attr('data-muted') != 'undefined' ? $(this).attr('data-muted')  : 0;
        playsinline = typeof $(this).attr('data-playsinline') != 'undefined' ? $(this).attr('data-playsinline') : 0;
        loop = typeof $(this).attr('data-loop') != 'undefined' ? $(this).attr('data-loop') : 0;
        autoplay = typeof $(this).attr('data-autoplay') != 'undefined' ? $(this).attr('data-autoplay') : 0;

        if($(this).attr('id') == ''){
            var cloned_id = ytid +'-'+ Math.ceil(Math.random()*100000000);
            $(this).attr('id',cloned_id);
            theID = $(this).attr('id');
        }

        /* Slick slider videos do not need to worry about related videos at the end as they
        are designed to loop, on mute - mainly for header sliders. Plus Youtube functions
        don't seem to work with them */
        if($(this).closest('.slick-slide').length){
            player = new YT.Player(theID, {
                playerVars: {
                    'rel': 0,
                    'iv_load_policy': 3,
                    'playsinline': 1,
                    'origin': window.location.hostname,
                    'controls': ytcontrols,
                    'playsinline': playsinline,
                    'loop': loop,
                    'disablekb': 1,
                    'fs': 1,
                    'modestbranding': 1,
                    'color': '#DAC287',
                },
                videoId: ytid,
                events: {
                    'onReady': onPlayerReady
                }
            });
        } else {
            player = new YT.Player(theID, {
                playerVars: {
                    'rel': 0,
                    'iv_load_policy': 3,
                    'playsinline': 1,
                    'origin': window.location.hostname,
                    'controls': ytcontrols,
                    'playsinline': playsinline,
                    'loop': loop,
                    'disablekb': 1,
                    'fs': 1,
                    'modestbranding': 1,
                    'color': '#DAC287',
                },
                videoId: ytid,
                events: {
                    'onReady': onPlayerReady,
                    'onStateChange': onPlayerStateChange,
                }
            });
        }

        function onPlayerReady(event) {
            if(muted == 1){
                event.target.mute();
            }
            if(autoplay == 1){
                event.target.playVideo();
            }
        }
    });
}


$(document).on('click','.video-embed-container .play', function(){
    console.log('click');
    if($(this).hasClass('html5')){
        $(this).siblings('video').get(0).play();
    } else if($(this).hasClass('youtube_play')){
        var ytid = $(this).parent().siblings('.youtube_video_container').attr('id');
        $(this).parent().fadeOut(1000);
        
        ytid = $('#'+ytid);
        ytid[0].contentWindow.postMessage(`{
            "event":"command",
            "func":"${'playVideo'}",
            "args":""
        }`, '*');
    } else if($(this).hasClass('vimeo_play')){
        var vid = $(this).parent().siblings('.vimeo').attr('id');
        $(this).parent().fadeOut(1000);
        vimeo_player[vid].api('play');
    }

    return false;
});


$(document).ready(function(){
    $('video').each(function(){
        var video = $(this).get(0);
        video.onplay = function() {
            $(this).siblings('.play').fadeOut(1000);
        }
        video.onpause = function() {
            $(this).siblings('.play').fadeIn(0);
        } 
    });
});